
import ClimaApp from '../components/ClimaApp';




const Inicio = () => {
  
    return(
        <div>       
            <ClimaApp/>              
        </div>

    )
}
export default Inicio